// extracted by mini-css-extract-plugin
module.exports = {"icon":"CloseButton_icon__UuHUY","small":"CloseButton_small__2VWEk"};